import { Box, Text, THEME_UTILITIES, useBrand } from '@cof/plastic-components';
import { styled } from 'styled-components';
import PropTypes from 'prop-types';
import capitalOnePhoneConfetti from './assets/capitalOnePhoneConfetti.png';
import asosPhoneConfetti from './assets/asosiPhoneConfetti.png';
import veryPhoneConfetti from './assets/veryiPhoneConfetti.png';
import littlewoodsPhoneConfetti from './assets/littlewoodsiPhoneConfetti.png';
import lumaPhoneConfetti from './assets/lumaiPhoneConfetti.png';

import partners from '../../partners';
import { withText } from '../../text/textStore';

const GradientBorderBox = styled(Box)`
    background: ${({ $borderBackground }: any) => $borderBackground};
    border-radius: 0.8rem;
    padding: 0.1rem;
    min-width: 31.1rem;
    height: 7rem;
    max-width: 43.5rem;
    overflow: visible;
`;

const InnerBox = styled(Box)`
    border-radius: 0.75rem;
    width: 100%;
    height: 100%;
    padding: 2.45rem 1.6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const PhoneImage = styled.img`
    position: absolute;
    bottom: -6rem;
    right: 2.4rem;
    width: 7.6rem;
    z-index: 1;

    ${({ theme }: any) => theme.breakpoints.mq.tabletMin} {
        width: 8.4rem;
        bottom: -7.5rem;
    }
`;

const { useColor } = THEME_UTILITIES;

const GenericBannerBase = ({ $borderBackground, Text: text = false }: any) => {
    const headingBox = useColor({
        [partners.ASOS]: 'ASOS.purple350',
        [partners.CAPITAL_ONE]: '#27314a',
        [partners.LITTLEWOODS]: 'littlewoods.purple550',
        [partners.LUMA]: 'luma.purple500',
        [partners.VERY]: 'very.pink500'
    });

    const brandMobileImage = {
        [partners.ASOS]: asosPhoneConfetti,
        [partners.CAPITAL_ONE]: capitalOnePhoneConfetti,
        [partners.LITTLEWOODS]: littlewoodsPhoneConfetti,
        [partners.LUMA]: lumaPhoneConfetti,
        [partners.VERY]: veryPhoneConfetti
    };

    const brand = useBrand();

    return (
        <GradientBorderBox
            width={['93%', null, '100%']}
            // @ts-expect-error TS2769: No overload matches this call.
            $borderBackground={$borderBackground}
            data-qa-id="generic-banner"
            data-qm-allow
        >
            <InnerBox
                style={{ position: 'relative', clipPath: 'inset(-100% -100% 0 -100%)' }}
                backgroundColor={headingBox}
                data-qm-allow
            >
                <Text
                    color={'global.white'}
                    fontSize={['textMediumMobile', null, 'textLargeDesktop']}
                    fontWeight={'medium'}
                    data-qa-id={`reason-3-text`}
                    data-qm-allow
                    style={{ zIndex: 2, paddingRight: '9.2rem' }}
                >
                    {text({ path: `ReasonText.Header` })}
                </Text>
                <PhoneImage src={brandMobileImage[brand]} data-qa-id={`iPhone-front-confetti`} alt="" />
            </InnerBox>
        </GradientBorderBox>
    );
};

GenericBannerBase.propTypes = {
    $borderBackground: PropTypes.string.isRequired,
    Text: PropTypes.func.isRequired
};

const GenericBanner = withText('SimpleHeader.GenericHeader')(GenericBannerBase);
GenericBanner.displayName = 'GenericBanner';

export default GenericBanner;
